import { Box, Icon, Link, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getReceipt } from 'services/api/modules/recruitment/order'
import { downloadUrlFile, notifyDownloadError } from 'services/helper/fileDownload'

const {
  default: AdxFullWindowTitleBar,
} = require('components/reusable/fullWindowTitleBar/AdxFullWindowTitleBar')

const PaymentStatusCandidatePurchase = ({ isSuccess = true }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const data = location.state?.data

  //api call for get receipt
  const [isLoadingDownload, setIsLoadingDownload] = useState(false)
  const handleDownload = async () => {
    setIsLoadingDownload(true)
    try {
      const pdfLink = await getReceipt(data?.data.order_id)
      setIsLoadingDownload(false)
      downloadUrlFile({
        url: pdfLink,
        fileName: `${data?.data.order_id}_invoice.pdf`,
        successMessage: 'Receipt downloaded.',
        revokeObjectUrl: true,
      })
    } catch (error) {
      setIsLoadingDownload(false)
      notifyDownloadError('Unable to download receipt. Please try again.')
      console.log(error)
    }
  }

  //change the timestamp to dd/mm/yyy, hh:mm am/pm format
  const dt = new Date(data?.data.updated_at)
  const formattedDate = dt.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })

  //check of the time is in PM and the hour clock is 00, change it 12
  const [newDate, setNewDate] = useState(null)
  useEffect(() => {
    if (isSuccess) {
      const [dateString, time] = formattedDate?.split(', ')
      const [hour, minuteTemp] = time?.split(':')
      const [minute, ampm] = minuteTemp?.split(' ')
      const convertTime = (ampm, dateString, minuteTemp, hour, formattedDate) => {
        if (ampm === 'pm' && hour === '00') {
          return `${dateString}, 12:${minuteTemp}`
        } else {
          return formattedDate
        }
      }
      setNewDate(convertTime(ampm, dateString, minuteTemp, hour, formattedDate))
    }
  }, [])

  // close button action
  const handleClose = () => {
    navigate('/app/recruitment')
  }
  const returnToCart = () => {
    navigate('/app/recruitment/cart')
  }
  const goToCreditTopUp = () => {
    navigate('/app/recruitment/credit/top-up')
  }
  return (
    <Box bgcolor="gray-background.main" sx={{ height: '100%' }}>
      {isSuccess ? (
        <AdxFullWindowTitleBar onClose={handleClose}>Payment Successful</AdxFullWindowTitleBar>
      ) : (
        <AdxFullWindowTitleBar onClose={handleClose}>Payment Unsuccessful</AdxFullWindowTitleBar>
      )}
      <Box display="flex" justifyContent="center">
        <Box bgcolor="white.main" width={700} px={4} minHeight="calc(100vh - 59px)">
          {isSuccess ? (
            <Box display="flex" alignItems="center" flexDirection="column">
              <Icon
                sx={{
                  fontSize: '130px',
                  color: 'positive.main',
                }}
              >
                check_circle_icon
              </Icon>
              <Typography
                variant="h2"
                color="dark-text.main"
                marginTop={4}
                sx={{
                  fontWeight: 'bold',
                }}
              >
                Payment successful
              </Typography>
              <Typography
                marginTop={2}
                variant="body1"
                color="light-gray-text.main"
                sx={{
                  fontWeight: 'bold',
                }}
                textAlign="center"
              >
                Thank you, you have successfully made your payment for the following order ID.
              </Typography>
              <Typography
                variant="body1"
                color="light-gray-text.main"
                sx={{
                  fontWeight: 'bold',
                }}
                textAlign="center"
              >
                You can now view the purchased candidate.
              </Typography>
            </Box>
          ) : (
            <Box display="flex" alignItems="center" flexDirection="column">
              <Icon
                sx={{
                  fontSize: '130px',
                  color: 'error.main',
                }}
              >
                cancel_icon
              </Icon>
              <Typography
                variant="h2"
                color="dark-text.main"
                marginTop={4}
                sx={{
                  fontWeight: 'bold',
                }}
              >
                Payment unsuccesful!
              </Typography>
              <Typography
                marginTop={2}
                variant="body1"
                color="light-gray-text.main"
                sx={{
                  fontWeight: 'bold',
                }}
                textAlign="center"
              >
                Thank you for your attempted payment. Unfortunately, your payment cannot be
                processed. Please try again.
              </Typography>
            </Box>
          )}

          {data?.data.order_id !== undefined ? (
            <Box mt={4} px={4} py={1} bgcolor="gray-background.main">
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h4" color="light-gray-text.main">
                  Order ID
                </Typography>
                <Typography variant="h4" color="light-gray-text.main">
                  {data?.data.order_id}
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginTop={4}
                marginBottom={2}
              >
                <Typography variant="h4" color="light-gray-text.main">
                  Transaction type
                </Typography>
                {data?.data.order_type === 'candidate_purchase' ? (
                  <Typography variant="h4" color="light-gray-text.main">
                    Candidate purchase
                  </Typography>
                ) : (
                  <Typography variant="h4" color="light-gray-text.main">
                    Credit topup
                  </Typography>
                )}
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginTop={4}
                marginBottom={2}
              >
                <Typography variant="h4" color="light-gray-text.main">
                  Amount paid
                </Typography>
                <Typography variant="h4" color="light-gray-text.main">
                  RM {data?.data.credit_used}.00
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginTop={4}
                marginBottom={2}
              >
                <Typography variant="h4" color="light-gray-text.main">
                  Payment Date
                </Typography>
                <Typography variant="h4" color="light-gray-text.main">
                  {newDate ?? 0}
                </Typography>
              </Box>
            </Box>
          ) : null}

          <Box marginTop={6} display="flex" flexDirection="column" alignItems="center">
            <Box display="flex" columnGap={0.5} marginBottom={1}>
              <Typography variant="body2" color="light-gray-text.main">
                Need help?
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {' '}
                <Link
                  onClick={() => window.open('https://adnexio.jobs/contact-us', '_blank')}
                  color="alternate.main"
                >
                  Contact Us
                </Link>
              </Typography>
              <Typography variant="body2" color="light-gray-text.main">
                for inquiries
              </Typography>
            </Box>
            <AdxButton
              variant={'contained'}
              size="standard"
              sx={{ width: 500 }}
              onClick={handleClose}
            >
              Return
            </AdxButton>
            {data?.data.order_id !== undefined ? (
              <AdxButton
                variant={'outlined'}
                size="standard"
                sx={{ width: 500, marginTop: 1 }}
                onClick={handleDownload}
                isLoading={isLoadingDownload}
              >
                Download receipt
              </AdxButton>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
export default PaymentStatusCandidatePurchase
